<template>
  <b-modal
    title="NOVA UNIDADE DE MEDIDA"
    id="new_unit_of_measurement"
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <label>TIPO</label>
          <b-select
            v-model="type_id"
            :options="typesOfMeasure"
            text-field="name"
            value-field="id"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>NOME</label>
          <b-input v-model="name" ref="autofocus"></b-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>ABREVIAÇÃO</label>
          <b-input v-model="abbreviation"></b-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>VALUE</label>
          <b-input v-model="value"></b-input>
        </b-col>
      </b-row>
      <b-row v-if="type_convertible">
        <b-col>
          <label>{{ type_base }} em {{ name }}</label>
          <b-input v-model.number="multiple"></b-input>
        </b-col>
      </b-row>
      <errors-messages :errors="errors" />
      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn type="submit" color="v-success"> SALVAR </v-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import toast from "../../../components/ToastNotification";
import api from "../../../services/api";
import ErrorsMessages from "../../components/ErrorsMessages.vue";
export default {
  components: { ErrorsMessages },
  name: "NewUnitOfMeasurement",

  data() {
    return {
      errors: [],
      loading: false,

      typesOfMeasure: [],

      type_id: "",
      name: "",
      abbreviation: "",
      value: "",
      multiple: "",
    };
  },

  created() {
    this.getTypesOfMeasure();
  },

  computed: {
    type_base() {
      return this.type_id
        ? this.typesOfMeasure.find((item) => item.id === this.type_id).base
        : "";
    },

    type_convertible() {
      return this.type_id
        ? this.typesOfMeasure.find((item) => item.id === this.type_id)
            .convertible
        : false;
    },
  },

  methods: {
    async evOnShow() {
      this.errors = [];
      this.loading = false;

      this.type_id = "";
      this.name = "";
      this.abbreviation = "";
      this.value = "";
      this.multiple = "";
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          stock_item_type_of_measure_id: this.type_id,
          name: this.name,
          abbreviation: this.abbreviation,
          value: this.value,
          multiple: this.type_convertible ? this.multiple : 1,
        };
        const response = await api.post(
          "/admin/rest-home/stock/items/unit-of-measurement",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("new_unit_of_measurement");
          this.$emit("created");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async getTypesOfMeasure() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/stock/items/units-of-measurement/types"
        );
        const { error, errors, typesOfMeasure } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.typesOfMeasure = typesOfMeasure;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>